module.exports = __webpack_public_path__ + "img/stranger-trip-to-china.d59415ef.jpg";